import routes from '../../../constants/routes';
import { providersListPathWithSearch, PROVIDERS_LIST_STATE_KEY, readProvidersListSearch } from './providersListState';

export { PROVIDERS_LIST_STATE_KEY };

export interface ProviderDetailLocationState {
	providersListSearch?: string;
}

export type ProviderDetailTab = 'data' | 'payment-rule' | 'calendar-config' | 'schedule' | 'payables' | 'payments';

const TAB_URL_MAP: Record<ProviderDetailTab, string> = {
	data: 'datos',
	'payment-rule': 'regla-pago',
	'calendar-config': 'calendario',
	schedule: 'agenda-pagos',
	payables: 'lineas',
	payments: 'pagos',
};

const URL_TAB_MAP: Record<string, ProviderDetailTab> = Object.fromEntries(
	Object.entries(TAB_URL_MAP).map(([tab, url]) => [url, tab as ProviderDetailTab]),
);

export const buildProviderDetailUrl = (id: string, tab?: ProviderDetailTab): string => {
	const base = routes.providers.detail.replace(':id', id);
	if (!tab || tab === 'data') return base;
	return `${base}?tab=${TAB_URL_MAP[tab]}`;
};

export const providerDetailTabFromSearch = (search: string): ProviderDetailTab => {
	const tab = new URLSearchParams(search).get('tab');
	return (tab && URL_TAB_MAP[tab]) || 'data';
};

export const getProviderDetailBackRoute = (state?: ProviderDetailLocationState | null): string => {
	const search = state?.[PROVIDERS_LIST_STATE_KEY] ?? readProvidersListSearch();
	return providersListPathWithSearch(search);
};
